import axios from "axios";
export const insertCompany = async (comData) => {
  try {
    const response = await axios.post("http://localhost:8080/webnet-hms/api/company/", comData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
    window.alert("company inserted successfully:", response.data);
    return response.data;
  } catch (error) {
    window.alert("Error inserting comapny:", error);
  }
};